Vue.component('BloodResultProviderIndexComponent', require('./components/BloodResultProvidersIndexComponent').default);
Vue.component('BloodResultProviderGetComponent', require('./components/BloodResultProvidersFormComponent').default);

Vue.component('NewLaboratoryForm', require('./components/laboratories-partials/NewLaboratoryForm').default);
Vue.component('NewCollectionCentre', require('./components/laboratories-partials/NewCollectionCentre').default);
Vue.component('LaboratoryCCActions', require('./components/laboratories-partials/LaboratoryCCActions').default);
Vue.component('LaboratoryCCDataTable', require('./components/laboratories-partials/LaboratoryCCDataTable').default);
